export const USER_MANAGEMENT_UPLOAD_FILE_SUCCESS =
  'USER_MANAGEMENT_UPLOAD_FILE_SUCCESS';
export const USER_MANAGEMENT_UPLOAD_FILE_FAILURE =
  'USER_MANAGEMENT_UPLOAD_FILE_FAILURE';
